import { render, staticRenderFns } from "./ResearchMQQPlot.vue?vue&type=template&id=fdd9300a"
import script from "./ResearchMQQPlot.vue?vue&type=script&lang=js"
export * from "./ResearchMQQPlot.vue?vue&type=script&lang=js"
import style0 from "./ResearchMQQPlot.vue?vue&type=style&index=0&id=fdd9300a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdd9300a')) {
      api.createRecord('fdd9300a', component.options)
    } else {
      api.reload('fdd9300a', component.options)
    }
    module.hot.accept("./ResearchMQQPlot.vue?vue&type=template&id=fdd9300a", function () {
      api.rerender('fdd9300a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchMQQPlot.vue"
export default component.exports